<i18n src="@/i18n/components/EditButton.json"></i18n>
<template>
	<router-link tag="button" :to="to"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
		<i class="mr-2.5" :class="icon"></i>
        <span class="text-sm font-medium">
            <slot>{{ $t('edit_button.label') }}</slot>
        </span>
    </router-link>
</template>

<script>
export default {
    name: "EditButton",
	props: {
		to: [Object, String],
		icon: {
			type: String,
			default: "fa fa-edit"
		}
	}
}
</script>
